// 初始化全局ttx对象，避免覆盖已有属性
window.ttx = window.ttx || {};
ttx.log = {}

/**
 * 日志工具封装
 * 特性：
 * 1. 带时间戳、日志级别、类型标识
 * 2. 支持日志级别过滤（生产环境可关闭debug）
 * 3. 错误日志自动打印堆栈
 * 4. 统一格式化输出，支持多参数
 * 5. 类型校验，避免参数错误
 */
ttx.log = (function () {
    // 日志级别配置（可根据环境调整，如生产环境设为INFO）
    const LOG_LEVELS = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        SUCCESS: 4 // 自定义成功级别
    };
    // 当前日志级别（开发环境默认DEBUG，生产可改为INFO）
    let currentLevel = LOG_LEVELS.DEBUG;

    // 日志样式（可选，让控制台输出更美观）
    const LOG_STYLES = {
        DEBUG: 'color: #909399;',
        INFO: 'color: #409EFF;',
        WARN: 'color: #E6A23C;',
        ERROR: 'color: #F56C6C;',
        SUCCESS: 'color: #67C23A;'
    };

    /**
     * 核心日志方法
     * @param {string} level - 日志级别
     * @param {any[]} args - 日志参数（支持多参数）
     */
    function log(level, ...args) {
        // 过滤低于当前级别的日志
        if (LOG_LEVELS[level] < currentLevel) return;

        // 格式化时间戳（YYYY-MM-DD HH:mm:ss.ms）
        const now = new Date();
        const timeStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}.${String(now.getMilliseconds()).padStart(3, '0')}`;

        // 统一日志前缀
        const prefix = `[TX ${level}] [${timeStr}]`;

        // 处理错误堆栈（仅ERROR级别）
        let logArgs = [prefix, ...args];
        if (level === 'ERROR' && args[0] instanceof Error) {
            logArgs = [prefix, args[0].message, args[0].stack];
        }

        // 控制台输出（带样式）
        console.log(`%c${logArgs[0]}`, LOG_STYLES[level] || '', ...logArgs.slice(1));
    }

    return {
        // 设置日志级别（如：ttx.log.setLevel('INFO')）
        setLevel: function (level) {
            if (LOG_LEVELS[level]) {
                currentLevel = LOG_LEVELS[level];
            } else {
                console.warn('[TX LOG] 无效的日志级别，可选值：DEBUG/INFO/WARN/ERROR/SUCCESS');
            }
        },

        // 调试日志（开发环境用，生产可关闭）
        debug: function (...args) {
            log('DEBUG', ...args);
        },

        // 信息日志
        info: function (...args) {
            log('INFO', ...args);
        },

        // 警告日志
        warn: function (...args) {
            log('WARN', ...args);
        },

        // 错误日志（支持Error对象，自动打印堆栈）
        error: function (...args) {
            log('ERROR', ...args);
        },

        // 成功日志（自定义）
        success: function (...args) {
            log('SUCCESS', ...args);
        },

        // 获取当前日志级别
        getCurrentLevel: function () {
            return Object.keys(LOG_LEVELS).find(key => LOG_LEVELS[key] === currentLevel);
        }
    };
})();